import { render, staticRenderFns } from "./lawRoleSelect.vue?vue&type=template&id=19d6b646&scoped=true"
import script from "./lawRoleSelect.vue?vue&type=script&lang=js"
export * from "./lawRoleSelect.vue?vue&type=script&lang=js"
import style0 from "./lawRoleSelect.vue?vue&type=style&index=0&id=19d6b646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6b646",
  null
  
)

export default component.exports